import { LogManager } from '@do/do-web-sdk';
export const logManager = new LogManager();
logManager.init({
  env: window.ENV_CONFIG.env,
  app: '则形',
  source: 'Web端-工作台',
  logUrl: window.ENV_CONFIG.logEsUrl ?? '',
});
